import { render, staticRenderFns } from "./FooterCTA.vue?vue&type=template&id=dd3ba394&scoped=true"
import script from "./FooterCTA.vue?vue&type=script&lang=js"
export * from "./FooterCTA.vue?vue&type=script&lang=js"
import style0 from "./FooterCTA.vue?vue&type=style&index=0&id=dd3ba394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3ba394",
  null
  
)

export default component.exports